import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { Container, Row, Col } from "reactstrap";
import NavigationComponent from "~/components/NavigationComponent";
import FooterComponent from "~/components/FooterComponent";

import styles from "./About.scss";

class AboutRoute extends React.Component {
  //-----------------------------------------------------------------------
  // Lifecycle
  //-----------------------------------------------------------------------
  componentDidMount() {
    // Initialize perfect scrollbar
    $("#app").perfectScrollbar({ suppressScrollX: true });
  }

  //-----------------------------------------------------------------------
  // Render
  //-----------------------------------------------------------------------
  render() {
    return (
      <div id="about_route">
        <Container id="navigation">
          <NavigationComponent />
        </Container>

        <Container id="about">
          <Row>
            <Col xs="12">
              <h1>About</h1>
              <p>
                I’m Holger Sindbaek and I’m the creator of these Jigsaw puzzles games. I didn't invent jigsaw puzzles, but I made a nice online version of it.
                <br />
                <br />
                All the jigsaw puzzles you see are available as a free download both for Windows™, Mac™, Linux™, iOS or Android.
                <br />
                <br />
                If you like puzzle games I can highly recommend <a href="https://mexicantrain.com/">Mexican Train Dominoes</a> game. It's a fun an free puzzle game where you play agains three opponents. You can choose to play against the computer and even invite your friends to play!
                <br />
                <br />
                If playing dice is more your thing, I'd suggest trying out <a href="https://playbunco.com/">Bunco</a>. It's a game of chance traditionally played by 12 people and it's loads of fun!
              </p>
            </Col>
          </Row>
        </Container>

        <Container id="footer">
          <FooterComponent />
        </Container>
      </div>
    );
  }
}

export default withStyles(styles)(AboutRoute);



// WEBPACK FOOTER //
// ./src/routes/about/About.js